<template>
  <div class="alert errInfo">
    <h6 class="text-start">Insights Generation Failed. You can</h6>
    <ul class="bulletList">
      <li>Retry Changing the Filters</li>
      <li>Click <a class="cursor-pointer mailLink" @click="sendErr()">
          <div class="letter-image">
            <div class="animated-mail">
              <div class="back-fold"></div>
              <div class="letter">
                <div class="letter-border"></div>
                <div class="letter-title"></div>
                <div class="letter-context"></div>
                <div class="letter-stamp">
                  <div class="letter-stamp-inner"></div>
                </div>
              </div>
              <div class="top-fold"></div>
              <div class="body"></div>
              <div class="left-fold"></div>
            </div>
          </div>
        </a> to report issue to Support Team</li>
    </ul>
  </div>
</template>
<script>
import sendErrorMail from "./../../mixin/sendErrorMail";
export default {
  name: 'insightErrMsg',
  mixins: [sendErrorMail],
  props: {
    compTitle: String,
    compId: String,
  },
  methods: {
    sendErr() {
      this.errorMail(this.compTitle, this.compId)
    }
  }
}
</script>
<style scoped>
.errInfo {
  margin-top: 20px;
  display: block;
  top: 100px;
  color: #f14a4a;
  position: inherit;
}

.errInfo .far:hover,
.errInfo .fas:hover {
  box-shadow: 0 0 10px 0 inset, 0 0 3px 0 rgb(237 49 49);
}

li {
  text-align: left;
}

a {
  /* font-size: 16px; */
  margin: 0 4px;
  display: inline-block;
}</style>
